import React, { useState, useEffect } from "react";
import "./styles.scss";
import { Link } from "react-router-dom";
import ComfortTradeModal from "../ComfortTradeModal";
import { formateCoins, newpromotion, promotion } from "../../function";
import { Spin, Collapse, Input, Button, message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { checkCoupon, getAvailableCoupons } from "../../services/coupons/couponsApi";
import { useCurrency } from "../../context/CurrencyContext";


const { Panel } = Collapse;


export default function Card_sale({ selectedOffer, setDiscount, discount }) {
  const { t } = useTranslation();
  const { formatPrice, currency, getSymbol } = useCurrency();
  const [isOpenComfortTrade, setIsOpenComfortTrade] = useState(false);
  const [couponCode, setCouponCode] = useState("");
  const [isApplyingCoupon, setIsApplyingCoupon] = useState(false);
  const [myCoupons, setMyCoupons] = useState([]);
  const [isLoadingCoupons, setIsLoadingCoupons] = useState(false);
  const [showMyCouponsModal, setShowMyCouponsModal] = useState(false);



  // Fonction utilitaire pour formater les montants
  const formatMontant = (montant) => {
    return parseFloat(montant || 0).toFixed(2);
  };
  // Vérifier si l'utilisateur est connecté
  const isAuthenticated = () => {
    return localStorage.getItem('authToken') !== null;
  };

  useEffect(() => {
    setDiscount(0)
  }, [selectedOffer])

  // Charger les coupons de l'utilisateur
  const loadMyCoupons = async () => {
    if (!isAuthenticated()) return;

    setIsLoadingCoupons(true);
    try {
      const response = await getAvailableCoupons();
      if (response.success) {
        setMyCoupons(response.data || []);
      }
    } catch (error) {
      console.error('Erreur lors du chargement des coupons:', error);
    } finally {
      setIsLoadingCoupons(false);
    }
  };

  // Sélectionner un coupon
  const selectCoupon = (coupon) => {
    setCouponCode(coupon.code);
    setShowMyCouponsModal(false);
    message.success(t('Coupon sélectionné: ') + coupon.code);
  };

  // Ouvrir le modal des coupons
  const openMyCouponsModal = () => {
    if (!isAuthenticated()) {
      message.warning(t('Veuillez vous connecter pour voir vos coupons'));
      return;
    }
    loadMyCoupons();
    setShowMyCouponsModal(true);
  };

  const validCoupon = async () => {
    if (!couponCode.trim()) {
      message.error(t('Veuillez saisir un code coupon'));
      return;
    }

    setIsApplyingCoupon(true);

    try {
      const response = await checkCoupon(couponCode.trim(), selectedOffer.montant);

      if (response.success) {
        message.success(t('Coupon appliqué avec succès ! Remise de ') + formatPrice(response.discount) + ' ' + currency);
        setDiscount(response.discount);
        localStorage.setItem('couponCode', couponCode.trim());
      } else {
        message.error(response.message || t('Erreur lors de la validation du coupon'));
      }
    } catch (error) {
      setDiscount(0);


      if (error.response?.data?.message) {
        message.error(error.response.data.message);
      } else if (error.response?.status === 400) {
        message.error(t('Coupon invalide ou expiré'));
      } else if (error.response?.status === 404) {
        message.error(t('Code coupon non trouvé'));
      } else {
        message.error(t('Erreur lors de la validation du coupon'));
      }
    } finally {
      setIsApplyingCoupon(false);
    }
  };



  return (
    <>
      <div className="new_offers_card">
        <ul className="new_offers_details_list">
          <li className="new_offers_detail_item">
            <label className="new_offers_detail_label" title="Platform">
              {t('Type')}
            </label>
            <div className="new_offers_detail_value" title="PS4/PS5">
              <span>{selectedOffer.type_name ?? ""}</span>
            </div>
          </li>

          <li className="new_offers_detail_item">
            <label className="new_offers_detail_label" >
              {t('price')}
            </label>
            <div className="new_offers_detail_value" >
              <span>
                {selectedOffer.coins ? formateCoins(selectedOffer.coins) : ""}
              </span>
            </div>
          </li>

          <li className="new_offers_detail_item">
            <label className="new_offers_detail_label" >
              {t('Methodes')}
            </label>
            <div className="new_offers_detail_value" >
              <i
                onClick={() => setIsOpenComfortTrade(true)}
                className="bi bi-question-circle"
                style={{ cursor: "pointer" }}
              ></i>
              <span>Comfort Trade</span>
            </div>
          </li>

          {/* <li className="new_offers_detail_item">
            <label className="new_offers_detail_label" title="Complete Time">
              Complete Time
            </label>
            <div className="new_offers_detail_value" title="0.5-1Hour">
              <span>0.5-1Hour</span>
            </div>
          </li> */}
        </ul>

        <div className="new_offers_divider"></div>

        {/* Section Coupon */}
        <div className="new_offers_coupon_section mt-0" style={{ marginBottom: "15px" }}>
          <Collapse
            ghost
            size="small"
            style={{ backgroundColor: "transparent" }}
          >
            <Panel

              header={
                <span style={{ color: "var(--input-color)", fontSize: "14px" }}>
                  <i className="bi bi-ticket-perforated" style={{ marginRight: "8px" }}></i>
                  {t('Avez-vous un code coupon?')}
                </span>
              }
              key="1"
            >
              <div className="copon_V2_wrapper">
                <div className="copon_V2_inputWrapper" tabIndex={-1}>
                  <span className="copon_V2_prefix">
                    <span className="copon_V2_iconWrapper">
                      <i className="copon_V2_icon" />
                    </span>
                  </span>

                  <input
                    type="text"
                    autoComplete="off"
                    tabIndex={0}
                    placeholder={t("Entrez un code de réduction")}
                    id="el-id-1197-79"
                    className="copon_V2_input"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                    onKeyPress={(e) => {
                      if (e.key === 'Enter') {
                        validCoupon();
                      }
                    }}
                    disabled={isApplyingCoupon}
                  />

                  <span className="copon_V2_suffix">
                    <span className="copon_V2_iconWrapper" />
                  </span>
                </div>

                <div className="copon_V2_buttonWrapper" onClick={validCoupon}>
                  <div className="copon_V2_button">
                    {isApplyingCoupon ? (
                      <Spin size="small" />
                    ) : (
                      t('UTILISER')
                    )}
                  </div>
                </div>
              </div>

              {/* Bouton Mes Coupons */}
              <div style={{ marginTop: "10px", textAlign: "center" }}>
                <Button
                  type="link"
                  onClick={openMyCouponsModal}
                  style={{
                    color: "var(--primary-color)",
                    fontSize: "12px",
                    padding: "0"
                  }}
                >
                  <i className="bi bi-wallet2" style={{ marginRight: "5px" }}></i>
                  {t('Mes Coupons')}
                </Button>
              </div>

            </Panel>
          </Collapse>
        </div>

        <div className="new_offers_total_section">
          <dl className="new_offers_total_container">
            <dt className="new_offers_total_label">{t('Montant')}</dt>
            {/* <dd className="new_offers_total_amount">
              {selectedOffer.promotion && selectedOffer.promotion > 0 && (
                <span
                  style={{
                    textDecoration: "line-through",
                    color: "red",
                    fontSize: "14px",
                    marginRight: "10px",
                  }}
                >
                  {selectedOffer.montant
                    ? newpromotion(
                        selectedOffer.montant,
                        selectedOffer?.promotion ?? 0
                      )
                    : ""}{" "}
                  USD
                </span>
              )}
              <span>{(selectedOffer.montant - discount) ? selectedOffer.montant - discount : 0}</span>
              <span className="new_offers_currency">USD</span>
            </dd> */}
            <dd className="new_offers_total_amount">
              {selectedOffer.promotion && selectedOffer.promotion > 0 && (
                <span
                  style={{
                    textDecoration: "line-through",
                    color: "red",
                    fontSize: "14px",
                    marginRight: "10px",
                  }}
                >
                  {/* Formatage du montant original */}
                  {selectedOffer.montant
                    ? formatPrice(newpromotion(
                      selectedOffer.montant,
                      selectedOffer?.promotion ?? 0
                    ))
                    : "0.00"}{" "}
                  {currency}
                </span>
              )}
              {/* Montant final après toutes les réductions */}
              <span>
                {selectedOffer.montant
                  ? formatPrice(selectedOffer.montant - discount)
                  : "0.00"
                }
              </span>
              <span className="new_offers_currency">{currency}</span>
            </dd>
          </dl>

          {selectedOffer.id ?
            <Link
              to={`Offer/${selectedOffer.id}`}
              className="new_offers_buy_button"
            >
              {t("buyCoins")}
            </Link>
            :
            <Spin />
          }
        </div>

        <div className="new_offers_features">
          <span className="new_offers_feature">
            <label>7 Days Guarantee</label>
          </span>
          <span className="new_offers_feature">
            <label>5% Tax Covered</label>
          </span>
          <span className="new_offers_feature">
            <label>Trusted 10+ Years</label>
          </span>
        </div>
      </div>
      <ComfortTradeModal
        isOpen={isOpenComfortTrade}
        setIsOpen={() => setIsOpenComfortTrade(false)}
      />

      {/* Modal Mes Coupons */}
      <Modal
        title={
          <span>
            <i className="bi bi-wallet2" style={{ marginRight: "8px" }}></i>
            {t('Mes Coupons')}
          </span>
        }
        open={showMyCouponsModal}
        onCancel={() => setShowMyCouponsModal(false)}
        footer={null}
        width={500}
      >
        {isLoadingCoupons ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <Spin size="large" />
            <p style={{ marginTop: "10px" }}>{t('Chargement de vos coupons...')}</p>
          </div>
        ) : myCoupons.length === 0 ? (
          <div style={{ textAlign: "center", padding: "20px" }}>
            <i className="bi bi-ticket-perforated" style={{ fontSize: "48px", color: "#ccc", marginBottom: "10px" }}></i>
            <p>{t('Aucun coupon disponible')}</p>
          </div>
        ) : (
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            {myCoupons.map((coupon, index) => (
              <div
                key={index}
                style={{
                  border: "1px solid #e8e8e8",
                  borderRadius: "8px",
                  padding: "15px",
                  marginBottom: "10px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  backgroundColor: "var(--background-body)"
                }}
                onMouseEnter={(e) => {
                  // e.target.style.backgroundColor = "#f0f0f0";
                  e.target.style.borderColor = "var(--primary-color)";
                }}
                onMouseLeave={(e) => {
                  // e.target.style.backgroundColor = "#fafafa";
                  e.target.style.borderColor = "#e8e8e8";
                }}
                onClick={() => selectCoupon(coupon)}
              >
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                  <div>
                    <h4 style={{ margin: "0 0 5px 0", color: "var(--primary-color)" }}>
                      {coupon.code}
                    </h4>
                    <p style={{ margin: "0", fontSize: "12px", color: "#666" }}>
                      {coupon.description || t('Coupon de réduction')}
                    </p>
                    <p style={{ margin: "5px 0 0 0", fontSize: "10px", color: "#999" }}>
                      {t('Valide jusqu\'au')}: {new Date(coupon.valid_until).toLocaleDateString()}
                    </p>
                  </div>
                  <div style={{ textAlign: "right" }}>
                    <div style={{
                      fontSize: "18px",
                      fontWeight: "bold",
                      color: "#52c41a"
                    }}>
                      {coupon.value}
                      {coupon.type === 'percentage' ? '%' : ' USD'}
                    </div>
                    <div style={{ fontSize: "10px", color: "#999" }}>
                      {t('Cliquez pour sélectionner')}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </Modal>
    </>
  );
}
